import * as React from 'react';
import * as Typography from '../../../atoms/Typography/Typography.js';
import { Container, Content, ContentText, Footer, Button } from './SimpleCookieForm.styles.js';

var SimpleCookieForm = function (_a) {
    var title = _a.title, allowAllBtnText = _a.allowAllBtnText, disclaimer = _a.disclaimer, discoverMore = _a.discoverMore, expandPreferencesBtnText = _a.expandPreferencesBtnText, onSavePreferences = _a.onSavePreferences, onExpandPreferences = _a.onExpandPreferences;
    return (React.createElement(Container, { "data-testid": "SimpleCookieForm" },
        React.createElement("header", null,
            React.createElement(Typography.Heading, { as: "h2" }, title)),
        React.createElement(Content, null,
            React.createElement(ContentText, { as: "p", variant: "footnote" }, disclaimer),
            React.createElement("br", null),
            React.createElement(ContentText, { as: "p", variant: "footnote" }, discoverMore)),
        React.createElement(Footer, null,
            React.createElement(Button, { variant: "primary", onClick: onSavePreferences }, allowAllBtnText),
            React.createElement(Button, { variant: "tertiary", onClick: onExpandPreferences }, expandPreferencesBtnText))));
};

export { SimpleCookieForm as default };
//# sourceMappingURL=SimpleCookieForm.js.map
